<template>
  <div class="c-material-report">
    <report-filter ref="filter" slot="filter" :data="filtersData" @on-change="filterData" @on-search="searchFilterData" />
    <div class="c-m-table">
      <div class="c-table-list">
        <QueryParamsManager
          ref="queryParamsManager"
          menu-id="M21000"
          :max-conditions="20"
          @select="onConditionSelect"
          @request-save="onSaveRequest"
        />

        <div class="right-btns">
          <div class="realtime">
            <div class="empty-filter">
              <el-switch v-model="emptyFilterSwitch" @change="$refs.filter.sendEvent()"></el-switch>
              <span>&ensp;过滤消耗为0数据</span>
            </div>
            <div class="sync-time"><i class="el-icon-refresh"></i> 数据同步时间：{{ nowDate }}</div>
          </div>
          <Button icon="md-download" @click="downData" :loading="exportLoading">数据导出</Button>
          <Button @click="modalColumn = true">自定义列</Button>
        </div>
      </div>

      <Viewport v-model="tableHeight">
        <p-detail-table
          ref="planDataTable"
          :height="tableHeight"
          :loading="loading"
          :data="tableList"
          :columns="tableCol"
          :summary="summaries"
          @on-sort="sortTable"
          @on-show="handleShow"
          @header-dragend="headerDragend"
          @on-refresh="getData"
        />

        <Page
          show-total
          show-sizer
          show-elevator
          class="c-table-page pager"
          size="small"
          :total="total"
          :current.sync="pageIndex"
          :page-size="pageSizePrivate"
          :page-size-opts="[10, 20, 30, 40, 100]"
          @on-change="changePageIndex"
          @on-page-size-change="changePageSizePrivate"
        />
      </Viewport>
    </div>
    <!-- <custom-column v-model="modalColumn" :data="columns" :sub-title="['基础信息', '报表数据']" @on-select="selectColumn" /> -->
    <!-- 自定义列 -->
    <custom-column
      ref="tableCustomColsRef"
      v-model="modalColumn"
      name="realTimeDataCustomColumn"
      :data="rawTableCols"
      :sub-title="['', '报表数据']"
      @on-select="onTableColsChange"
    />
  </div>
</template>
<script>
import { isArray, isEmpty, throttle, formatDate } from '@/common/js/utils' //, timeout
import { REPORT_REALTIME } from '@/views/download-center/data/const.js'

import mixinTable from './js//mixin_table'
import { complexRestCols } from './data/real_column.js'
import CustomColumn from '@/components/converter/custom-column2'
import QueryParamsManager from '@/components/query-params-manager/index.vue'
import ReportFilter from './components/report-filter.vue'
import PDetailTable from './components/effect-table'

import { checkedData, dimensionsData } from './js/dimensionsData.js'

import { getComplexReport, initDownloadCenterTask } from '@/api/report.model'

import { getPtomGroupGames } from '@/api/material.model'
import { getSysAdvertPosition, adAccount, getSysProject, adGames, getSysMedia, adPtom } from '@/api/common.model'

import { toThousands, toPercentFixed } from '@/common/js/filters'
import { thousands } from './js/judge-table'

const now = formatDate(new Date(), 'yyyy-MM-dd')
export default {
  name: 'realtime-report',
  mixins: [mixinTable],
  components: { CustomColumn, PDetailTable, QueryParamsManager, ReportFilter },
  computed: {
    tableCol() {
      const firstCol = {
        title: '日期',
        key: 'tdate',
        type: 'disabled',
        width: 100,
        fixed: true
      }
      // 如果带有维度查询，表格列前面新增对应的列显示；
      const dimensionCols = this.addOnDimensions.map((d) => ({ ...d, fixed: true, checked: true }))
      const addCols = [firstCol, ...dimensionCols]
      const tableColumns = this.tableColumns.filter((c) => c.checked)
      return [...addCols, ...tableColumns]
    }
  },
  methods: {
    filterData(params) {
      this.nowDate = formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss')
      const addDimens = []
      for (const k in params) {
        if (params[k]) dimensionsData.map((i) => k === i.showKey && addDimens.push(i))
      }

      this.addOnDimensions = addDimens

      this.pageIndex = 1
      this.tableList = []
      this.getData(params)
    },
    filterSave(params) {
      this.filters = params
      this.condClick('add')
    },
    getData(filter) {
      if (this.loading) return
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSizePrivate,
        beginTime: this.datetime[0],
        endTime: this.datetime[1],
        sort: this.sort,
        order: this.order,
        dateType: 5,
        limitConsumption: this.emptyFilterSwitch ? 1 : 0
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      // 保存参数
      this.params = JSON.parse(JSON.stringify(params))
      this.loading = true
      getComplexReport(params).then((data) => {
        if (typeof data !== 'symbol') this.loading = false
        if (!data) return
        const { list, page_info, sum_data } = data
        sum_data && (this.sumdata = sum_data)
        isArray(list) && (this.tableList = list)
        if (isArray(list) && page_info) {
          const { total_number } = page_info
          this.total = total_number || 0
        } else this.tableList = []
        this.$nextTick(() => {
          this.$refs.planDataTable && this.$refs.planDataTable.doLayout()
        })
      })
    },
    downData() {
      const exportColumnOrderMap = {}
      this.tableCol.forEach((col) => {
        if ((col.checked || col.type === 'disabled') && !col.exclude_export) exportColumnOrderMap[col.key] = col.title
      })

      const conditionText = this.$refs.filter.getTransferedTaskQueryConditions({}, REPORT_REALTIME)
      const params = Object.assign(this.params, {
        firstTime: new Date().getTime(),
        exportColumnOrderMap,
        conditionText
      })
      this.exportLoading = true
      initDownloadCenterTask({
        pageType: REPORT_REALTIME,
        queryCondition: params
      }).then((data) => {
        this.exportLoading = false
        if (data.msg) {
          this.$Message.success(data.msg)
          this.$store.commit('setDownloadBadgeActive', 1)
        }
      })
    },
    summaries(param) {
      const { columns } = param
      const data = JSON.parse(JSON.stringify(this.sumdata))
      const sums = []
      columns.forEach((column, index) => {
        const prop = column.property
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (
          prop.indexOf('Rate') > -1 ||
          prop.indexOf('Retain') > -1 ||
          prop.indexOf('RoleRoi') > -1 ||
          ['createRoleTotalRoi'].includes(prop)
        ) {
          sums[index] = toPercentFixed(data[prop])
        } else if (this.thousands.includes(prop)) sums[index] = toThousands(data[prop])
        else sums[index] = data[prop]
      })
      return sums
    },
    handleShow(param) {
      const { key, row } = param
      let src
      if (key === 'imageName') {
        src = row.imageAddr
        const videoUrl = row.videoUrl
        const video = !isEmpty(videoUrl)
        this.$Gallery.open({ src, video, videoUrl })
      }
    },
    changePageSizePrivate(size) {
      this.pageSizePrivate = size
      if (this.pageIndex === 1) this.getData()
    },

    onSaveRequest() {
      this.$nextTick(() => {
        const params = this.$refs.filter.buildParams()
        this.$refs.queryParamsManager.openSaveDialog(params)
      })
    },

    onConditionSelect(cond) {
      if (this.$refs.filter && cond) {
        const { conditionInfo } = cond
        if (!isEmpty(conditionInfo)) {
          const {
            initProjectGroupIds,
            adAccountIdList,
            gameIds,
            gameGroupIds,
            opIds,
            advPositionIds,
            optimizationTypes,
            deepOptimizationTypes,
            mediaIds,
            platforms,
            launchSource,
            ptomPlan,
            ptomImage,
            order,
            sort
          } = JSON.parse(conditionInfo)
          !isEmpty(sort) && (this.sort = sort)
          !isEmpty(order) && (this.order = order)

          this.$nextTick(() => {
            Object.assign(this.$refs.filter, {
              initProjectGroupIds: initProjectGroupIds || [],
              adAccountIdList: adAccountIdList || [],
              gameIds: gameIds || [],
              gameGroupIds: gameGroupIds || [],
              opIds: opIds || [],
              advPositionIds: advPositionIds || [],
              optimizationTypes: optimizationTypes || [],
              deepOptimizationTypes: deepOptimizationTypes || [],
              mediaIds: mediaIds || [],
              platforms: platforms || [],
              launchSource: launchSource || '',
              planTagLists: ptomPlan || [],
              imageTagLists: ptomImage || []
            })
          })
          const checkAllArr = [
            'dimPlan',
            'dimImage',
            'dimPlatform',
            'dimGameGroup',
            'dimGame',
            'dimProjectGroup',
            'dimOp',
            'dimMedia',
            'dimAdvPosition',
            'dimAdAccount',
            'dimOptimizationType',
            'dimDeepOptimizationType',
            'dimLaunchSource'
          ]
          const checkedBack = []
          this.$refs.filter.checkedDimens = []
          for (const k in this.$refs.filter.checkedParams) {
            // 选择常用查询条件时重置维度选择
            this.$set(this.$refs.filter.checkedParams, k, 0)
          }
          for (const k in JSON.parse(conditionInfo)) {
            checkAllArr.forEach((item) => {
              if (item === k) {
                checkedBack.push(item)
                this.$set(this.$refs.filter.checkedParams, item, 1)
              }
            })
            this.checkedData.forEach((item) => {
              if (k && item.key === k) {
                this.$refs.filter.checkedDimens.push(item.label)
              }
            })
          }
          this.$refs.filter.checkAll = checkedBack.length === 13
          this.$refs.filter.isIndeterminate = checkedBack.length === 13
        }
      }
    },
    proLoadData() {
      Promise.all([
        getSysAdvertPosition(), // 广告位
        getSysProject(), // 项目组
        adAccount({ authFlag: 1 }), // 账号
        getPtomGroupGames(), // 应用组
        adGames({ type: 1 }), // 应用
        getSysMedia(), // 媒体
        adPtom({ authFlag: 1 }) // 人员
      ])
        .then((data) => {
          const [
            advPositionIdsData,
            initProjectGroupIdsData,
            adAccountIdListIdsData,
            gameGroupIdsData,
            gameIdsData,
            mediaIdsData,
            opIdsData
          ] = data
          this.filtersData = {
            advPositionIdsData,
            initProjectGroupIdsData,
            adAccountIdListIdsData,
            gameGroupIdsData: gameGroupIdsData.map((ret) => {
              return {
                id: ret.groupId,
                name: ret.groupName
              }
            }),
            gameIdsData,
            mediaIdsData,
            opIdsData: opIdsData.map((ret) => {
              return {
                id: ret.opId,
                name: ret.name
              }
            })
          }
        })
        .catch((error) => {
          this.$Message.error({
            duration: 5,
            content: error
          })
        })
    },
    headerDragend({ n, column }) {
      this.$refs.tableCustomColsRef.updateTableColWidth(n, column)
    },
    onTableColsChange(cols) {
      this.tableColumns = cols
      this.modalColumn = false
    }
  },
  watch: {
    datetime() {
      throttle(() => {
        this.pageIndex = 1
        if (this.params) this.$refs.filter.sendEvent()
        else this.getData({})
      }, 600)()
    }
  },
  data() {
    return {
      rawTableCols: complexRestCols,
      tableColumns: [], // 表格字段
      tableHeight: 330,
      pageSizePrivate: 20, // 自定义默认页面尺寸
      tableList: [], // 表格数据
      sumdata: [], // 合计数据
      addOnDimensions: [], // 查询时勾选的维度，获取结果后需要新增到表格列前面
      emptyFilterSwitch: false,

      filtersData: {
        gameGroupIdsData: [],
        gameIdsData: [],
        initProjectGroupIdsData: [],
        opIdsData: [],
        mediaIdsData: [],
        advPositionIdsData: [],
        adAccountIdListIdsData: []
      },
      checkedData,
      nowDate: formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
      thousands,
      exportLoading: false
    }
  },
  created() {
    this.datetime = [now, now]
    this.comDate = [now, now]
    this.proLoadData()
  }
}
</script>
<style lang="scss" scoped>
.c-material-report {
  height: 100%;

  .c-btn-group {
    line-height: 30px;
    height: 32px;
    border-radius: 3px;
    width: 100px;
    display: inline-block;
    vertical-align: middle;
  }

  .c-table-list {
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .c-drop-btn {
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      display: inline-block;
      vertical-align: middle;
      max-width: 120px;
      padding-right: 5px;
    }

    .spin-quering {
      position: relative;
      min-width: 100px;
      min-height: 30px;
    }
    .right-btns {
      display: flex;

      .realtime {
        display: flex;
        align-items: center;
        .empty-filter {
          margin-right: 5px;
        }
        .sync-time {
          padding: 0 10px;
          line-height: 32px;
          background: rgba(0, 0, 0, 0.1);
          border-radius: 4px;
          margin-right: 3px;
        }
      }
    }
  }

  .c-table-page {
    padding: 5px 0;
    text-align: right;
  }

  .el-icon-refresh {
    font-size: 15px;
    vertical-align: middle;
  }
}
</style>
